var HeadLogin = require("pc-login").loginBtnIndex
import LazyLoad from "@/components/lazyload"
const { bindAriaEvent } = require("./utils/bindAria");

import Vue from "vue";
import Recommend from './pages/collection/comps/recommend.vue'
import Share from './vuecomps/shareCollection.vue'
import { renderRightBtns } from '@/pages/article_main/js/handleDom'

export default function (opts) {
    window.pcArticleInfo = {
        id: opts.id
    }
    window.LazyLoad = new LazyLoad();
    // 右侧悬浮按钮
   renderRightBtns()

    // 分享
    if(document.querySelector("#share") ){
        new Vue({
            el: "#share",
            components: {
                Share
            },
        })
    }
    //登录条
    new HeadLogin({
        el: "#head-login",
        mark: "article",
        type: "other"
    });

     // feed流
    if(document.querySelector("#collectionFeed") ){
		new Vue({
			el: "#collectionFeed",
			components: {
				Recommend
			},
		})
	}
    // 处理无障碍，关怀版点击绑定
    bindAriaEvent()
}
